module.exports = __webpack_public_path__ + "img/bg2@2x.a63737fe.png";